const codeMessageMap: Record<string, string> = {
	"0000": "(정상완료)",
	"1203": "(전산 작업중 추후전송요망)",
	"1204": "(02-3416-2900 문의 요망)",
	"1205": "(테스트 ID 거래 문의:1600-1234)",
	"1206": "(농협재승인)",
	"1207": "(국민 LMS MS 거래 EMVS 로 전환)",
	"1208": "(MS 거래 요망)",
	"1209": "(거래불가 POS 거래 아님)",
	"1211": "(재거래 요망)",
	"1213": "(망취소미사용)",
	"1214": "(알리페이결제 테스트거래입니다)",
	"1215": "(해외카드거래불가)",
	"1301": "(승인거절 ver1.3.4 앱 업데이트 요망)",
	"2016": "(미등록가맹점)",
	"4201": "(요청 전문 오류)",
	"4215": "(SIGN KEY 값 오류)",
	"4216": "(재조회 요망)",
	"4217": "(SIGN FLAG 오류)",
	"4218": "(인증구분필드오류)",
	"4224": "(통신구분 오류)",
	"4250": "(전문구분코드오류)",
	"4251": "(단말기 번호 오류)",
	"4252": "(WCC 필드 오류)",
	"4253": "(카드번호필드오류)",
	"4254": "(유효기간필드오류)",
	"4255": "(거래금액필드오류)",
	"4256": "(할부개월필드오류)",
	"4257": "(봉사료 필드 오류)",
	"4258": "(세금 필드 오류)",
	"4259": "(가맹점 번호 오류)",
	"4260": "(사업자 번호 오류)",
	"4261": "(정산건수필드오류)",
	"4262": "(정산금액필드오류)",
	"4263": "(R 거래가 허용안됨)",
	"4264": "(포인트율필드오류)",
	"4265": "(주유량 필드 오류)",
	"4266": "(원거래 일자 오류)",
	"4267": "(거래일련번호오류)",
	"4268": "(Point 카드 Key-In 거래불가)",
	"4269": "(원승인 번호 오류)",
	"4271": "(추후 서비스 예정)",
	"4272": "(사용할 수 없는 단말기 번호)",
	"4274": "(단가를입력하세요)",
	"4275": "(유종단가입력오류)",
	"4276": "(R 거래가 허용안됨)",
	"4277": "(R 거래가 허용안됨)",
	"4278": "(R 거래가 허용안됨)",
	"4279": "(재조회 요망)",
	"4280": "(재조회 요망)",
	"4281": "(상품코드입력오류)",
	"4282": "(조회일자입력오류)",
	"4284": "(재조회 요망)",
	"4285": "(재조회 요망)",
	"4286": "(재조회 요망)",
	"4287": "(재조회 요망)",
	"4288": "(재조회 요망)",
	"4289": "(재조회 요망)",
	"4290": "(재조회 요망)",
	"4291": "(VAN CODE 오류)",
	"4292": "(할인금액입력오류)",
	"4293": "(당첨번호입력오류)",
	"4294": "(당첨번호 불일치)",
	"4295": "(당첨번호가맹점아님)",
	"4296": "(당첨 금액 불일치)",
	"4297": "(유효기간 경과)",
	"4298": "(면세유 입력 오류)",
	"4299": "(기 승인거래존재)",
	"4300": "(당첨거래조회장애일반신용거래요망)",
	"4310": "(조회기간오류)",
	"4311": "(매입사코드오류)",
	"4312": "(조회 PAGE 오류)",
	"4319": "(SIS 거래 불가)",
	"4320": "(NEWPOS 포멧오류)",
	"4322": "(조회기간 오류)",
	"4324": "(포인트카드 할부거래 불가)",
	"4332": "(통화코드 오류)",
	"4333": "(EMV DATA NULL)",
	"4334": "(EMV 요청 DATA 오류)",
	"4335": "(카드번호 2 오류)",
	"4336": "(유효기간 2 오류)",
	"4337": "(WCC2 필드오류)",
	"4338": "(거래금액필드오류)",
	"4339": "(현금거래 구분오류)",
	"4340": "(요청 전문 오류)",
	"4341": "(재조회 요망 (4341))",
	"4353": "(카드번호필드오류)",
	"4802": "(V.A.K. Error)",
	"4804": "(CheckValue Error)",
	"6310": "(재조회 요망 (6310))",
	"6610": "(재조회 요망 (6610))",
	"6620": "(재조회 요망 (6620))",
	"6630": "(재조회 요망 (6630))",
	"6640": "(재조회 요망 (6640))",
	"6650": "(재조회 요망 (6650))",
	"6660": "(재조회 요망 (6660))",
	"6661": "(재조회 요망 (6661))",
	"6670": "(재조회 요망 (6670))",
	"6680": "(재조회 요망 (6680))",
	"6690": "(재조회 요망 (6690))",
	"6802": "(재조회 요망 (6802))",
	"6803": "(재조회 요망 (6803))",
	"6804": "(재조회 요망 (6804))",
	"6805": "(재조회 요망 (6805))",
	"6806": "(재조회 요망 (6806))",
	"6807": "(재조회 요망 (6807))",
	"6808": "(재조회 요망 (6808))",
	"6809": "(재조회 요망 (6809))",
	"6999": "(이미 취소원복된 거래)",
	"7401": "(사고 신고 수표)",
	"7402": "(수표 발행 취소 수표)",
	"7403": "(기 지급된 수표)",
	"7405": "(기 조회된 수표)",
	"7406": "(수표 금액 상이)",
	"7407": "(수표 발행일 상이)",
	"7408": "(수표 번호 오류)",
	"7409": "(수표권종코드 오류)",
	"7410": "(수표발행지점 오류)",
	"7412": "(해당 은행 통신 장애)",
	"7415": "(미발행 수표)",
	"7416": "(발행 은행 문의 요망)",
	"7501": "(단말기 미등록 TEL (02)761-3000)",
	"7502": "(단말기번호 오류)",
	"7503": "(키 다운로드 요망)",
	"7504": "(관리 대리점 교체 요망!)",
	"7505": "(사업자번호 불일치)",
	"7506": "(환율정보 미등록)",
	"7507": "(Paterner ID 미등록 가맹점)",
	"7508": "(역환거래 불가)",
	"7570": "(할부 거래 불가능 가맹점)",
	"7571": "(할부 거래 불가능 가맹점)",
	"7581": "(승인 완료된 거래입니다.)",
	"7768": "(등록 작업시 당초매출일 오류)",
	"7769": "(등록 작업시 승인번호 오류)",
	"7781": "(정산 거래시 정산 오류)",
	"7792": "(전문구분 오류)",
	"7803": "(재조회 요망 (7803))",
	"7974": "(가맹점 등록 요망 TEL (02)761-3000)",
	"7975": "(국세청 전화 요망 (126))",
	"7979": "(해당 카드사에 가맹점정보 확인)",
	"8000": "(조회 불가능 카드)",
	"8001": "(허가된 거래가 아님)",
	"8002": "(허가된 사용자 아님)",
	"8003": "(FORMAT 오류 재시도 요망)",
	"8004": "(해외/법인 카드 아님)",
	"8005": "(국내카드 승인 불가)",
	"8006": "(거래 금액 너무 적음)",
	"8007": "(설치 거래 1,234 원 변경)",
	"8008": "(한도초과 금액)",
	"8009": "(거래금액 미입력)",
	"8010": "(*금액입력오류*)",
	"8011": "(승인이 제한된 금액입니다)",
	"8012": "(회원 이용실적 기준 미달)",
	"8013": "(원거래 주문번호 불일치)",
	"8014": "(배송비 할인금액 한도 초과)",
	"8015": "(청구시 할인대상 (현장할인 아님))",
	"8016": "(해당서비스 미연계 가맹점)",
	"8017": "(회원은행 불일치)",
	"8020": "(서비스 가능시간 아님)",
	"8021": "(인증 후 사용요망)",
	"8032": "(할부 금액 잘못 입력)",
	"8034": "(거래 정지 계좌)",
	"8035": "(잔액 부족)",
	"8036": "(잔액 20%이내 사용가능)",
	"8037": "(카드 번호 입력 오류)",
	"8038": "(신분확인정보 확인 요망)",
	"8110": "(수동 조회 불가능 카드)",
	"8120": "(수동 조회 불가능 가맹점)",
	"8121": "(당월중 수동조회 한도 초과)",
	"8122": "(자기매출 불가)",
	"8123": "(수동 조회 불가능 가맹점)",
	"8124": "(해당카드 거래 제한 업종)",
	"8125": "(PG 입점업체 사업자번호오류)",
	"8126": "(미등록 PG SUB 가맹점)",
	"8127": "(불량 PG SUB 가맹점)",
	"8178": "(연체 카드)",
	"8179": "(타 카드/은행 연체)",
	"8310": "(비밀번호 오류)",
	"8311": "(비밀번호 오류 회수 초과)",
	"8312": "(비밀번호 오류)",
	"8313": "(가맹점 한도초과)",
	"8314": "(유효 기간 경과 카드)",
	"8315": "(유효 기간 오류)",
	"8316": "(유효 기간 경과 카드)",
	"8318": "(비밀 번호 입력 요망)",
	"8319": "(비밀 번호 등록 요망)",
	"8321": "(1 일 사용 한도액 초과)",
	"8322": "(일반 구매 한도 초과)",
	"8323": "(할부 구매 한도 초과)",
	"8324": "(거래정지 카드)",
	"8325": "(승인 대행 한도 초과)",
	"8326": "(월 사용 한도액 초과)",
	"8327": "(1 회 사용 한도액 초과)",
	"8328": "(사용횟수 초과)",
	"8329": "(무통장 거래 횟수 초과)",
	"8330": "(사용시간 초과)",
	"8331": "(회원/가족 요청 거래 정지)",
	"8332": "(일일사용횟수초과)",
	"8333": "(월간사용횟수초과)",
	"8334": "(연간사용횟수초과)",
	"8335": "(분기사용횟수초과)",
	"8350": "(도난 / 분실 카드 카드사 신고)",
	"8351": "(사고등록 계좌)",
	"8352": "(법적등록 계좌)",
	"8353": "(카드사/은행 시스템 장애)",
	"8354": "(탈회/해지 카드)",
	"8355": "(미교부 카드)",
	"8356": "(카드사/은행 시스템 점검중)",
	"8371": "(카드사 전화요망)",
	"8372": "(카드사 전화요망)",
	"8373": "(카드사 전화요망)",
	"8374": "(취소기한 경과)",
	"8375": "(전화승인 요망)",
	"8376": "(IC 카드 승인 거절)",
	"8377": "(카드사/은행 확인 후 거래 요망)",
	"8378": "(IC 카드 인증오류)",
	"8380": "(통신 장애재조회 요망)",
	"8381": "(재조회 요망 카드사 장애)",
	"8391": "(할부 개월 입력 오류)",
	"8392": "(할부는 12 개월 이내)",
	"8393": "(할부 개월 입력 오류)",
	"8395": "(즉시입금/ 즉시입금취소오류)",
	"8396": "(할인 금액 미 존재)",
	"8397": "(승인 금액 미 존재)",
	"8398": "(원 거래 주문번호 틀림)",
	"8399": "(기준 실적 미달)",
	"8400": "(해당 카드사 통신 장애)",
	"8401": "(인증 서비스 대행승인 불가)",
	"8410": "(신용 조기경보 등재 회원)",
	"8411": "(카드발급상태이상)",
	"8412": "(신용 불량자)",
	"8413": "(위변조 카드)",
	"8414": "(승인 거래 없음)",
	"8415": "(거래 내역 없음)",
	"8416": "(할부 거래 불가능 카드)",
	"8417": "(할부 거래 불가능 카드)",
	"8418": "(서비스 불가능 카드)",
	"8419": "(MS 정보 불일치)",
	"8420": "(이미 EDI 매입된 거래 입니다)",
	"8431": "(승인 취소 불가)",
	"8432": "(이미 매입된 거래 입니다)",
	"8433": "(이미 취소된 거래 입니다)",
	"8434": "(PIN DOWNLOAD 재시도 요망)",
	"8435": "(IC 거래 요망)",
	"8501": "(전문 ID 오류)",
	"8502": "(상품코드오류 080-5000-011)",
	"8503": "(취소승인번호없음 080-5000-011)",
	"8504": "(취소할금액이다름 080-5000-011)",
	"8505": "(Check 기준오류)",
	"8506": "(VIP 아님 080-5000-011)",
	"8507": "(취소불가 기취소 080-5000-011)",
	"8508": "(Pos entry 오류 080-5000-011)",
	"8509": "(가맹점코드오류 080-5000-011)",
	"8510": "(통화코드오류)",
	"8511": "(거래금액오류 080-5000-011)",
	"8512": "(취소구분오류)",
	"8513": "(취소승인번호오류 080-5000-011)",
	"8514": "(도난/분실카드 080-5000-011)",
	"8515": "(거래정지카드 080-5000-011)",
	"8516": "(조회불능카드 080-5000-011)",
	"8517": "(불량가맹점)",
	"8518": "(해지가맹점 080-5000-011)",
	"8519": "(등록 VAN 사다름 080-5000-011)",
	"8520": "(말소단말기)",
	"8521": "(한도초과)",
	"8522": "(해당회원아님 080-5000-011)",
	"8523": "(재조회카드사장애 080-5000-011)",
	"8524": "(보너스포인트 사용불가 가맹점)",
	"8525": "(VIP 한도초과 080-555-0017)",
	"8526": "(재발급 대상카드 LGT 문의 1544- 0019)",
	"8527": "(포인트잔액 부족)",
	"8531": "(멤버쉽 번호 Update 필요)",
	"8532": "(상 환 방 법 입 력 오 류)",
	"8533": "(미 등 록 카 드)",
	"8534": "(포인트 사용불가)",
	"8535": "(인증서비스 불가 가맹점)",
	"8536": "(상품권 월 구매한도 초과)",
	"8537": "(포인트 버튼을 눌러 거래하세요)",
	"8538": "(배송 금액 한도 초과)",
	"8539": "(매출 캐쉬백 탑재 카드)",
	"8540": "(대상 카드 아님)",
	"8541": "(기 처리 데이터)",
	"8542": "(총매출금액 미 존재)",
	"8543": "(요청 매수 미 존재)",
	"8544": "(서비스관리번호 미 존재)",
	"8545": "(결재구분값 틀림)",
	"8546": "(최저사용포인트 미만)",
	"8547": "(최저거래금액 미만)",
	"8548": "(개인본인회원 아님)",
	"8549": "(포인트사용가맹점 아님)",
	"8550": "(서비스 대상 회원사카드 아님)",
	"8551": "(서비스 대상일 아님)",
	"8552": "(서비스대상브랜드 아님)",
	"8553": "(서비스 대상요일 아님)",
	"8554": "(건별대행 불가 거래)",
	"8600": "(체크카드 사용불가 가맹점)",
	"8601": "(체크카드 서비스 불가)",
	"8611": "(온라인 가맹점 거래 불가)",
	"8621": "(안심클릭으로 거래요망)",
	"8631": "(CAVV 값 불일치)",
	"8641": "(CAVV 취소후 재거래 요망)",
	"8651": "(CAVV 갱신 요망)",
	"8661": "(CAVV 전문 오류)",
	"8721": "(공인인증서 비밀번호등록요망)",
	"8722": "(ISP 승인대상 가맹점임)",
	"8723": "(ISP 거래승인 불가 대행 VAN 사임)",
	"8724": "(인터넷 승인 인증결제 오류)",
	"8725": "(충전불가 카드)",
	"8726": "(카드수령후 미등록 카드)",
	"8727": "(구카드, 신규수령카드 이용요망)",
	"8730": "(해외카드사 거절)",
	"8731": "(선불카드 거래 오류)",
	"8732": "(기프트카드 서비스 불가)",
	"8733": "(서비스불가 시간대)",
	"8734": "(사용가능 쿠폰없음)",
	"8735": "(서비스미등록 가맹점)",
	"8736": "(약정서 미등록 카드사 요망)",
	"8737": "(바우처승인 오류)",
	"8738": "(POS 보안모듈 미설치)",
	"8739": "(참가기관업무종료)",
	"8740": "(해당카드 거래 제한 시간대)",
	"8741": "(약정할부중복이용 불가)",
	"8742": "(유효기간경과 앱카드번호)",
	"8743": "(이미 사용한 앱카드번호)",
	"8744": "(납부자번호체계 불일치)",
	"8745": "(기타 입출금 불가능 계좌)",
	"8746": "(잡익편입계좌)",
	"8747": "(통장분실계좌)",
	"8748": "(통장정리후 사용가능)",
	"8749": "(자동납부 미등록 계좌)",
	"8750": "(자동이체 미등록 계좌)",
	"8751": "(금일출금건 존재 해지불가)",
	"8752": "(기등록기해지된 거래)",
	"8753": "(실명확인후 사용가능)",
	"8754": "(계좌번호틀림 확인후 사용)",
	"8755": "(예금입금한도초과)",
	"8756": "(인감분실도난계좌)",
	"8757": "(재조회 요망)",
	"8758": "(미인증 단말기)",
	"8760": "(발급토큰 이상)",
	"9001": "(결제예정일 입력 오류)",
	"9002": "(2 회이상 분할금지)",
	"9003": "(매출취소불가 카드사 전화요망)",
	"9050": "(승인누적횟수초과)",
	"9051": "(특정시간승인불가)",
	"9052": "(주유전용가맹점 아님)",
	"9053": "(CVC 오류 횟수초과)",
	"9054": "(중복승인불가)",
	"9055": "(사용불가승인채널)",
	"9090": "(수기전표 작성후 매입은행 제출)",
	"9950": "(주민 번호 / 사업자번호 오류)",
	"9990": "(KEY 관련 오류)",
	"9999": "(단말기 미완료 거래)"
}

export function getMessageByCode(code: string): string {
	return codeMessageMap[code];
}